import { Experiment } from '@types'
import survey from './survey'
import r1 from './r1'

const experiments: Experiment[] = [survey, r1]

export default experiments
